import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on navigation and updates document title.
const PageWrapper = ({ title, description, children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
  }, [title, description]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);

  return <main data-testid="page-wrapper" className="adhd-fade-up">{children}</main>;
};

export default PageWrapper;
